/* eslint-disable */


/**
 * Create styles for `<ReportForm />`
 * @param {Styles} styles The result of `createStyles`
 * @returns The `<ReportForm />` styles
 */
const reportFormStyles = ({ theme }) => ({
  noIcon: {
    marginLeft: 52,
  },
});

export default reportFormStyles;
